// Translator notes: HV → FI/EN gō read as "before" (in time) by what stands before it
// (engine rules/temporal-go.ts; Axel 2026-10-08).
// Each id is an engine note (`notes.add(text, id, args)`); collected by translator/notes.ts (import.meta.glob).
import { defineNotes } from '../note-defs';

export const notes = defineNotes({
  goBefore: {
    args: ['word'],
    fi: (a: string[]) => `”gō” sanan ”${a[0]}” jälkeen kertoo ajasta: ’ennen’ eikä ’alla’. Vaihtoehdoissa on myös ’alla’.`,
    en: (a) => `“gō” after “${a[0]}” tells time: “before”, not “under”. “Under” is in the alternatives.`,
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
